import './about.css';
import { AiOutlineThunderbolt } from "react-icons/ai";
import { FiHeart } from "react-icons/fi";
import { LiaUniversitySolid } from "react-icons/lia";
import { getExperienceYears, niecYear } from '../home';
import { IoBulbOutline } from "react-icons/io5";
import { TbTargetArrow } from "react-icons/tb";
import { HiOutlineTrophy } from "react-icons/hi2";

const experienceYears = getExperienceYears();

const MOTIVATIONS = [
    {
        id: 1,
        number: '01',
        title: 'DREAM',
        image:
            'assets/img/slide/home/dream.webp',
        text:
            'Mimpi adalah sebuah keinginan besar yang ada di dalam hati kita. NIEC memiliki mimpi untuk dapat membantu semua siswa Indonesia yang juga mempunyai mimpi untuk meraih pendidikan terbaik dan mencapai suksesnya.',
        icon: IoBulbOutline
    },
    {
        id: 2,
        number: '02',
        title: 'ACT',
        image:
            'assets/img/slide/home/act.webp',
        text:
            'Tindakan adalah sebuah proses perjalanan untuk mewujudkan mimpi dan kesuksesan. Di NIEC kami selalu mengevaluasi proses tindakan dan perjalanan kami sebagai sebuah konsultan pendidikan.',
        icon: TbTargetArrow
    },
    {
        id: 3,
        number: '03',
        title: 'SUCCEED',
        image:
            'assets/img/slide/home/succeed.webp',
        text:
            'Kesuksesan adalah cita cita dari mimpi dan tindakan kami. NIEC ingin membuat bangsa Indonesia bangga dengan kesuksesan siswa Indonesia di dunia global.',
        icon: HiOutlineTrophy
    },
];

const WHY_FEATURES = [
    {
        id: 1,
        variation: 'variation-1',
        number: '1',
        title: 'Informasi Cepat dan Tepat',
        image:
            'https://images.unsplash.com/photo-1587038787166-becd08a156f7?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        text:
            'Kami memberikan informasi akurat dan cepat mengenai pendidikan ke luar negeri',
        icon: AiOutlineThunderbolt
    },
    {
        id: 2,
        variation: 'variation-1',
        number: '2',
        title: 'Relasi yang erat siswa dan orang tua',
        image:
            'https://images.unsplash.com/photo-1641189684174-16e53d9cc829?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        text:
            'NIEC berlandaskan prinsip menjaga hubungan yang erat dan kekeluargaan',
        icon: FiHeart
    },
    {
        id: 3,
        variation: 'variation-1',
        number: '3',
        title: 'Banyak Pilihan Negara dan Sekolah',
        image:
            'https://images.unsplash.com/photo-1759849531885-6c15ce649ff8?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        text:
            'Tersedia banyak pilihan institusi dan negara tujuan pendidikan luar negeri',
        icon: LiaUniversitySolid
    },
];

const About = () => {
    return (
        <div className="about-page">
            {/* Hero Section */}
            <section
                className="about-hero"
                style={{
                    backgroundImage:
                        "url('/assets/img/slide/home/about.webp')",
                }}
            >
                <div className="about-hero-overlay"></div>
                <div className="container">
                    <div className="about-hero-content">
                        <p className="about-hero-brand">NIEC INDONESIA</p>
                        <h1 className="about-hero-title">Education Consultant</h1>
                        <p className="about-hero-subtitle">
                            Konsultan Pendidikan dengan pengalaman {experienceYears} tahun, telah membantu
                            ribuan anak Indonesia kuliah ke luar negeri
                        </p>
                        {/* <button className="btn-about-hero">JELAJAHI</button> */}
                    </div>
                </div>
            </section>

            {/* Motivation Section */}
            <section className="motivation-section">
                <div className="container">
                    <div className="motivation-header">
                        <h2>Our Motivation</h2>
                        <p>
                            Tiga nilai yang menjadi fondasi kami dalam mendampingi setiap
                            langkah perjalananmu.
                        </p>
                    </div>

                    <div className="motivation-cards-wrapper">
                        <div className="motivation-row">
                            {MOTIVATIONS.map((item) => (
                                <div className="motivation-card" key={item.id}>
                                    <div
                                        className="motivation-card-bg"
                                        style={{ backgroundImage: `url(${item.image})` }}
                                    />
                                    <div className="motivation-card-overlay">
                                        {/* <div className="motivation-number">{item.number}</div> */}
                                        <div className="motivation-caption">
                                            <div className="motivation-icon"><item.icon /></div>
                                            <h3 className="motivation-title">{item.title}</h3>
                                        </div>
                                        <p className="motivation-text">{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="why-choose-section">
                <div className="container">
                    <div className="why-header">
                        <h2>Mengapa NIEC Indonesia</h2>
                        <p>
                            Kami hadir untuk memastikan setiap langkah pendidikan luar negeri kamu terarah, aman, dan sesuai dengan potensi terbaikmu.
                        </p>
                    </div>

                    <div className="why-bento-grid">
                        {/* <div className="why-hero-card">
                            <img
                                src="/assets/img/slide/home/why.webp"
                                alt="Why Choose Us"
                                className="why-hero-bg"
                            />
                            <div className="why-hero-overlay">
                                <p>Why Choose Us</p>
                                <h3>
                                    Alasan NIEC
                                    <br />
                                    Indonesia
                                </h3>
                            </div>
                        </div> */}

                        {WHY_FEATURES.map((feature) => (
                            <div
                                key={feature.id}
                                className={`feature-card ${feature.variation}`}
                            >
                                {/* <img
                                    src={feature.image}
                                    alt={feature.title}
                                    className="feature-image"
                                /> */}
                                <div className="feature-icon">
                                    {<feature.icon size={28} />}
                                </div>
                                {/* <div className="feature-number">{feature.number}</div> */}
                                <div className="feature-text">
                                    <h4 className='pb-2'>{feature.title}</h4>
                                    <p>{feature.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;